/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/web-app-bff-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { DeleteFragmentDetailByIdMutationResponse, DeleteFragmentDetailByIdPathParams, DeleteFragmentDetailById403, DeleteFragmentDetailById404 } from "../models/DeleteFragmentDetailById";

export function getDeleteFragmentDetailByIdUrl(id: DeleteFragmentDetailByIdPathParams["id"]) {
  const res = { method: 'DELETE', url: `/fragments/${id}` as const }
  return res
}

/**
 * @summary Delete one fragment by id
 * {@link /fragments/:id}
 */
export async function deleteFragmentDetailById(id: DeleteFragmentDetailByIdPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<DeleteFragmentDetailByIdMutationResponse, ResponseErrorConfig<DeleteFragmentDetailById403 | DeleteFragmentDetailById404>, unknown>({ method : "DELETE", url : getDeleteFragmentDetailByIdUrl(id).url.toString(), ... requestConfig })
  return res.data
}